import { useContext, useEffect, useState } from 'react';
import context from '../../context/context';
import './load-more-button.scss';

const LoadMoreButton = ({ className }) => {
	const [loading, setLoading] = useState(false);
	const [totalPage, setTotalPage] = useState(0);
	const [page, setPage] = useState(1);
	const { additionalGlobal, setAdditionalGlobal, setTriggerRefresh } =
		useContext(context);

	useEffect(() => {
		if (additionalGlobal !== []) {
			setTotalPage(additionalGlobal.total_page);
			setLoading(additionalGlobal.loading);
		}
	}, [additionalGlobal]);

	const handleClick = () => {
		setPage((prev) => prev + 1);
		setAdditionalGlobal({
			...additionalGlobal,
			page: page + 1,
			loading: true,
		});
		setTriggerRefresh(true);
	};

	if (totalPage <= page && loading === false) {
		return <> </>;
	}

	return (
		<div className="load-more-button-wrapper">
			{loading ? (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 100 100"
					preserveAspectRatio="xMidYMid"
					aria-label="Loading"
				>
					<g>
						<circle r="20" fill="#0bb09f" cy="50" cx="30">
							<animate
								begin="-0.625s"
								values="30;70;30"
								keyTimes="0;0.5;1"
								dur="1.25s"
								repeatCount="indefinite"
								attributeName="cx"
							></animate>
						</circle>
						<circle r="20" fill="#42276c" cy="50" cx="70">
							<animate
								begin="0s"
								values="30;70;30"
								keyTimes="0;0.5;1"
								dur="1.25s"
								repeatCount="indefinite"
								attributeName="cx"
							></animate>
						</circle>
						<circle r="20" fill="#0bb09f" cy="50" cx="30">
							<animate
								begin="-0.625s"
								values="30;70;30"
								keyTimes="0;0.5;1"
								dur="1.25s"
								repeatCount="indefinite"
								attributeName="cx"
							></animate>
							<animate
								repeatCount="indefinite"
								dur="1.25s"
								keyTimes="0;0.499;0.5;1"
								calcMode="discrete"
								values="0;0;1;1"
								attributeName="fill-opacity"
							></animate>
						</circle>
						<g></g>
					</g>
				</svg>
			) : (
				<button
					className={`load-more-button load-more-button--${className}`}
					onClick={handleClick}
					aria-label="Load More"
				>
					Load More
				</button>
			)}
		</div>
	);
};

export default LoadMoreButton;
